// Per-slug service pages (huwelijk, zwangerschap, newborn, gezin, communie, bedrijven)
export const SERVICES = {
  huwelijk: {
    slug: "huwelijk",
    title: "Huwelijken",
    tagline: "Jullie liefde, jullie verhaal",
    intro:
      "Vier hoofdstukken van jullie dag — verlovingsblik, glazen champagne, de eerste dans. Ik loop mee, onopvallend en aandachtig. Documentaire fotografie met de warmte van een familielid en de precisie van een professional.",
    heroImage: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/qkoo343w_0B5A9325.webp",
    highlights: ["Professioneel & ervaren", "Pure emoties & echte momenten", "Hoge kwaliteit & zorgzaam", "Persoonlijke aanpak"],
    priceFrom: "Vanaf €895",
    galleryTag: "huwelijk",
    packages: [
      { name: "Bronze", price: "€895", features: ["4 uur fotografie", "Professioneel bewerkte foto's", "Online galerij"] },
      { name: "Silver", price: "€1.395", features: ["6 uur fotografie", "Professioneel bewerkte foto's", "Online galerij"] },
      { name: "Gold", price: "€1.895", features: ["8 uur fotografie", "Tweede fotograaf", "Online galerij"], featured: true },
      { name: "Platinum", price: "€2.495", features: ["Volledige dag (tot 12u)", "Tweede fotograaf", "Engagementshoot", "Preview binnen 72u"] },
    ],
    combos: ["wedding-combo"],
  },
  zwangerschap: {
    slug: "zwangerschap",
    title: "Zwangerschap",
    tagline: "Vier deze bijzondere periode",
    intro:
      "Van een nieuw leven in je buik tot de eerste stapjes van je kindje. Puur, liefdevol en onvergetelijk. Kies uit alle mogelijkheden — of combineer ze in één van onze combopakketten.",
    heroImage: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/hpwmyzd5_0B5A1126%20kopie2.webp",
    highlights: ["Op buitenlocatie", "Partner en broertjes/zusjes welkom", "Rustige, intieme sfeer", "Ideaal tussen 30 en 35 weken"],
    priceFrom: "€225 all-in",
    galleryTag: "zwangerschap",
    packages: [
      { name: "Gender Reveal Fotoshoot", price: "€225", tag: "Introductieprijs", features: ["1 uur fotoshoot", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Persoonlijke online galerij"], extras: ["Confettikanon (roze of blauw)"] },
      { name: "Zwangerschap Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Inclusief partner en/of broertjes/zusjes", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"] },
      { name: "Newborn Shoot", price: "€225", tag: "All-in", featured: true, features: ["1 uur fotoshoot", "Op locatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"], extras: ["Alle benodigdheden en props"] },
      { name: "Baby Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Geschikt vanaf 3 maanden", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"] },
      { name: "Cake Smash Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Op locatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"], extras: ["Taart naar keuze"] },
      { name: "Gezins- & Lifestyle Shoot", price: "€245", tag: "All-in", features: ["1,5 uur fotoshoot", "Gezin, kinderen & baby welkom", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"] },
    ],
    combos: ["baby-journey", "first-year", "memories-for-life", "max-journey"],
  },
  newborn: {
    slug: "newborn",
    title: "Newborn & Baby",
    tagline: "De eerste dagen — puur en zacht",
    intro:
      "Zo bijzonder en zo klein. Ik werk met veilige poseertechnieken en een warme sfeer, terwijl ouders zich mogen ontspannen met een koffie in de hand.",
    heroImage: "https://images.pexels.com/photos/17834926/pexels-photo-17834926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    highlights: ["Ideaal tussen dag 5 en dag 14", "Warme, veilige sfeer", "Alle rekwisieten voorzien", "Familieportretten inbegrepen"],
    priceFrom: "€225 all-in",
    galleryTag: "newborn",
    packages: [
      { name: "Newborn Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Op locatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"], extras: ["Alle benodigdheden en props"], featured: true },
      { name: "Baby Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Geschikt vanaf 3 maanden", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"] },
      { name: "Cake Smash Shoot", price: "€225", tag: "All-in", features: ["1 uur fotoshoot", "Op locatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"], extras: ["Taart naar keuze"] },
    ],
    combos: ["baby-journey", "first-year", "memories-for-life", "max-journey"],
  },
  gezin: {
    slug: "gezin",
    title: "Gezin",
    tagline: "Jullie verhaal, in beeld",
    intro:
      "Samen genieten, lachen, knuffelen en herinneringen maken. Kinderen doen wat kinderen doen — ik leg vast wat er écht gebeurt.",
    heroImage: "https://images.pexels.com/photos/8730072/pexels-photo-8730072.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    highlights: ["Op buitenlocatie", "Ontspannen, speelse aanpak", "Ideaal bij zacht daglicht", "Digitale galerij + optioneel print"],
    priceFrom: "€195 all-in",
    galleryTag: "gezin",
    subcategoriesTitle: "Van kleine momenten naar grote herinneringen",
    subcategories: [
      {
        title: "FAMILIE SHOOTS",
        desc: "Samen genieten, lachen, knuffelen en herinneringen maken.",
        image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/7goxnl6a_0B5A0628%20kopie.webp",
        cta: "Familieshoot boeken",
        message: "Hallo Eric, ik wil graag info over een familie shoot.",
      },
      {
        title: "KINDERPORTRETTEN",
        desc: "Pure kinderfotografie met oog voor karakter en emotie.",
        image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/eh7mvja7_0B5A0913%20kopie2%20%281%29.webp",
        cta: "Kinderportret boeken",
        message: "Hallo Eric, ik wil graag info over een kinderportret.",
      },
      {
        title: "COMMUNIE / LENTEFEEST",
        desc: "Een bijzondere mijlpaal verdient prachtige foto's.",
        image: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/d68pkv6t_55c42148f45a37f1e62247a770308d9f.jpg",
        cta: "Communie / Lentefeest boeken",
        message: "Hallo Eric, ik wil graag info over een communie / lentefeest shoot.",
        highlight: true,
        linkTo: "/communie",
        badge: "In de kijker",
      },
    ],
    packages: [
      { name: "Gezins- & Lifestyle Shoot", price: "€195", tag: "All-in", features: ["1 uur fotoshoot", "Gezin, kinderen & baby welkom", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's in hoge resolutie", "Online galerij"], featured: true },
      { name: "Basic", price: "€145", features: ["45 minuten fotoshoot", "Op buitenlocatie", "minimum 5 professioneel bewerkte foto's", "Online galerij"] },
      { name: "Comfort", price: "€295", features: ["1,5 uur fotoshoot", "Op buitenlocatie", "minimum 15 professioneel bewerkte foto's", "Online galerij"] },
    ],
    combos: ["memories-for-life"],
  },
  communie: {
    slug: "communie",
    title: "Communie / Lentefeest",
    tagline: "Een bijzondere stap in hun leven",
    intro:
      "De eerste communie, plechtige communie of lentefeest is een dag die snel voorbij is. Ik zorg voor tijdloze portretten en warme sfeerbeelden — thuis, in de kerk of op locatie.",
    heroImage: "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/d68pkv6t_55c42148f45a37f1e62247a770308d9f.jpg",
    highlights: ["Portret + reportage stijl", "Vóór, tijdens en na de plechtigheid", "Familieportretten inbegrepen", "Snelle levering"],
    priceFrom: "€195",
    galleryTag: "gezin",
    packages: [
      { name: "Basis", price: "€195", features: ["1 à 1,5 uur fotoshoot", "Op buitenlocatie", "minimum 10 professioneel bewerkte foto's", "Online galerij"] },
      { name: "Comfort", price: "€295", features: ["2 uur fotoshoot", "Op buitenlocatie", "minimum 15 professioneel bewerkte foto's", "Online galerij"], featured: true },
      { name: "Luxe", price: "€395", features: ["2,5 uur fotoshoot", "Op buitenlocatie", "minimum 20 professioneel bewerkte foto's", "Online galerij"] },
    ],
    combos: [],
  },
  bedrijven: {
    slug: "bedrijven",
    title: "Bedrijven",
    tagline: "Professionele fotografie voor jouw merk",
    intro:
      "Van LinkedIn-portretten tot volledige bedrijfsreportages en corporate events. Krachtig, karaktervol beeld dat past bij het niveau van jouw onderneming.",
    heroImage: "https://customer-assets-eiarnc6j.emergentagent.net/job_capture-memories-11/artifacts/qembwk4n_Opdracht%20%2890%29%20kopie%20-%20kopie.webp",
    highlights: ["LinkedIn & teamportretten", "Corporate events", "Karaktervolle bedrijfsportretten", "Snelle levering op maat"],
    priceFrom: "Op aanvraag",
    galleryTag: "bedrijven",
    packages: [
      { name: "LinkedIn Portret", price: "Op aanvraag", features: ["Persoonlijk portret", "Snelle levering", "Bewerkte foto's", "Online galerij"] },
      { name: "Team & Event", price: "Op aanvraag", features: ["Op locatie", "Teamportretten", "Corporate reportage", "Online galerij"] },
    ],
    combos: [],
  },
};
